import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import SpinnerWrapper from '../../conponents/pages/spinnerWrapper';
import { BASE_URL, PROTECTED } from '../../constant-value';
import { setUser } from '../../redux/user/userSlice';
import api from '../../services/axiosConfig';
import { PuffLoader } from "react-spinners";


const ProtectedPageAxios = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
//   const userId = useSelector((state) => state.user.user.userId); // خواندن شناسه کاربر
// const user = useSelector((state) => state.user.user);


  const message = (message,type) => {
    if (type==='warn') {
      toast.error(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.success(message, {
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  useEffect(()=>{
    try {
       // بررسی اعتبار توکن
      api.get(PROTECTED)
              .then((res) => {
                setIsLoading(false);
                if (res.data.isSuccess) {           
                  setIsAuthenticated(true);
                  message(res.data.message,'success');
                  // dispatch(setUserIdFromBody(res.data.data));
                  const newUser = mapToUserDto(res.data.data)
                  // dispatch(setUserIdFromBody(newUser));
                  dispatch(setUser(newUser));
                } else {
                  setIsLoading(false); 
                  navigate(`/login`);
                  message(res.data.message,'warn');
                }});
 
    } catch (error) {
      setIsLoading(false);   
      navigate(`/login`); // هدایت به لاگین اگر خطای 401 دریافت شود
    }
  },[])

  // مپر برای تبدیل به مدل جدید
function mapToUserDto(oldUser) {
  if (oldUser.fileName === null) {
    oldUser.fileName='profile.jpg'
  }
  return {
    userId: oldUser.userId,
    userName: oldUser.userName,
    fullName: oldUser.fullName,
    gender:
      oldUser.gender === true || oldUser.gender === "true"
        ? true
        : oldUser.gender === false || oldUser.gender === "false"
        ? false
        : null,
    birthDate: oldUser.birthDate || null,
    registerDate: oldUser.registerDate || null,
    expireDate: oldUser.expireDate || null,
    imageUrl: BASE_URL + '/Images/Profile/' + oldUser.fileName,
    email: null, // چون در دیتای قدیمی وجود نداره
  };
}

  if (isLoading) {
    return (
      <SpinnerWrapper>
        <PuffLoader color="green" loading={true} size={60} />
      </SpinnerWrapper>
    );
  }
  return isAuthenticated ? children : null;
};

export default ProtectedPageAxios;